import { useLayoutEffect } from 'react';
import { useDeviceType } from '../../../../responsive';
/**
 * Хук, который управляет CSS-свойствами индикатора для активного таба
 */
export const useActiveIndicatorChange = _ref => {
  let {
    containerRef,
    activeTabIndex
  } = _ref;
  const deviceType = useDeviceType();
  useLayoutEffect(() => {
    const tabsNode = containerRef.current;
    if (tabsNode) {
      const activeTab = tabsNode.children.item(activeTabIndex);
      const {
        left,
        width
      } = activeTab.getBoundingClientRect();
      const distanceFromParent = left - tabsNode.getBoundingClientRect().left + tabsNode.scrollLeft;
      tabsNode.style.setProperty('--indicator-offset', "".concat(distanceFromParent, "px"));
      tabsNode.style.setProperty('--indicator-width', "".concat(width, "px"));
    }
  }, [activeTabIndex, containerRef, deviceType]);
};